import type { ConfigSection, GameProfile, ProfileCtx } from "./types";

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "TableSection", props: { name: "broadcastMessages" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "ConfSection", props: { name: "antiRaidSystem" } },
  { component: "ConfSection", props: { name: "pvp" } },
  { component: "ConfSection", props: { name: "stamina" } },
  { component: "ConfSection", props: { name: "storm" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  configSections,
  statusPageConfig: {
    showQueryPort: false,
    showRconPort: false,
    showFtp: false,
  },
});
